import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';

import { TextArea } from 'ui/text-area';
import Input from 'components/partials/input/input';

import { FORM_DEFAULTS } from 'components/partials/insight-modal/shared/constants';

export interface InsightFormValues {
  title: string;
  description: string;
}

interface TitleFieldProps {
  control: Control<InsightFormValues>;
  label?: string;
  placeholder?: string;
}

export const TitleField = ({
  control,
  label = 'Insight title',
  placeholder = 'Add insight title...',
}: TitleFieldProps) => (
  <Controller
    control={control}
    name="title"
    render={({ field }) => (
      <Input
        {...field}
        placeholder={placeholder}
        maxLength={FORM_DEFAULTS.maxTitleLength}
        required={true}
        label={label}
        labelInTop={true}
        customClass="!mt-0"
      />
    )}
  />
);

interface DescriptionFieldProps {
  control: Control<InsightFormValues>;
}

export const DescriptionField = ({ control }: DescriptionFieldProps) => (
  <Controller
    control={control}
    name="description"
    render={({ field }) => (
      <TextArea
        {...field}
        placeholder="Add summary..."
        rows={FORM_DEFAULTS.descriptionRows}
        maxLength={FORM_DEFAULTS.maxDescriptionLength}
        label="Summary"
        required
      />
    )}
  />
);
